export default {
    blocks: [0, 3, 3, 4],
    delimiters: ['(', ') ', '-'],
    numericOnly: true,
}